<template>
  <v-container :loading="loading">
    <RequiredFileManager
      v-for="(requiredFiles, title) in requiredFileGroups"
      :key="title"
      :required-files="requiredFiles"
      :add-title="title"
    />
    <FileManager
      :available-file-types="['Belege']"
      :model-type="{
        id: contract.number,
        model: 'Contract'
      }"
    />
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import FileManager from '@/Components/File/FileManager'
import RequiredFileManager from '@/Components/File/RequiredFileManager'

export default {
   components: {
      FileManager,
      RequiredFileManager
   },
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : `Vertrag ${this.contract.number}`,
      }
   },
   layout: (h, page) => h(Layout, [page]),

   props: {
      contract: {
         type: Object,
         required: true,
      },
      requiredFileGroups: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         loading: false,
         tab: 0,
      }
   },
}
</script>
